"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function () {
    var Source = function () {
        function Source($t) {
            _classCallCheck(this, Source);

            this.element = $t;
            this.section = $t.closest(".productlistsection");
            this.paramName = $t.attr("data-product-datatable-param-name");
            this.paramSource = (0, _jquery2.default)($t.attr("data-product-datatable-param-selector"));
            this.dataTableSelector = $t.attr("data-product-datatable-selector");
            $t.on($t.is(":input") ? "change" : "click", { that: this }, this._handle);
        }

        _createClass(Source, [{
            key: "highlight",
            value: function highlight(enable) {
                var val = this.element.val();
                var emptyVal = val == null || val.length === 0;
                if (enable) {
                    this.section.addClass("highlighted");
                    if (this.isEanSource && !emptyVal) this.element.val("").trigger('change.select2');
                } else {
                    this.section.removeClass("highlighted");
                    if (!emptyVal) this.element.val("").trigger('change');
                }
            }
        }, {
            key: "_handle",
            value: function _handle(e) {
                e.preventDefault();
                var that = e.data.that;
                if (that.isEanSource) {
                    var productListId = that.queryObject.productListId;
                    var productId = that.element.val();
                    highlightDropdown(that);
                    if (productId > 0) {
                        productListService.insertProduct({ ProductId: productId, ProductListId: productListId }).done(function (result) {
                            if (productListId !== result.id) {
                                that.paramSource.val(result.id);
                            }
                            _notify2.default.success(resx.App.SuccessfullySaved);
                            that._reloadTable();
                        }).fail(function () {
                            return _message2.default.error(resx.Common.AjaxError);
                        });
                    }
                } else {
                    if (that.highlatable) {
                        var val = that.element.val();
                        highlightDropdown(val == null || val === "" ? null : that);
                    }
                    that._reloadTable();
                }
            }
        }, {
            key: "_reloadTable",
            value: function _reloadTable() {
                var datatable = (0, _jquery2.default)(this.dataTableSelector).DataTable();
                datatable.query(this.queryObject).ajax.reload(null, false);
            }
        }, {
            key: "queryObject",
            get: function get() {
                var params = { productListId: null, editionId: null, query: null };
                params[this.paramName] = this.paramSource.val();
                return params;
            }
        }, {
            key: "highlatable",
            get: function get() {
                return !!this.section.length;
            }
        }, {
            key: "isEanSource",
            get: function get() {
                return this.paramName === "productListId";
            }
        }, {
            key: "isHighlighted",
            get: function get() {
                return this.highlatable && this.section.hasClass("highlighted");
            }
        }]);

        return Source;
    }();

    var sources = [];
    var highlatableSources = [];
    (0, _jquery2.default)("[data-product-lists-apply]", this).each(function () {
        var source = new Source((0, _jquery2.default)(this));
        sources.push(source);
        if (source.highlatable) {
            highlatableSources.push(source);
        }
    });

    highlightDropdown();
    (0, _jquery2.default)(".switch-toggle input[type=checkbox]", this).on("change", function () {
        var source = null;
        if ((0, _jquery2.default)(this).is(":checked")) {
            source = sources.find(function (src) {
                return !src.highlatable;
            });
        } else {
            source = sources.find(function (src) {
                return src.isHighlighted;
            });
        }
        if (source) source._reloadTable();
    });
    function highlightDropdown(toHighlight) {
        if (!toHighlight) {
            toHighlight = highlatableSources.find(function (src) {
                var val = src.element.val();
                return val != null && val !== "";
            });
            if (!toHighlight) {
                toHighlight = highlatableSources.find(function (src) {
                    return src.isEanSource;
                });
            }
        }
        highlatableSources.forEach(function (src) {
            src.highlight(src === toHighlight);
        });
    }
    (0, _jquery2.default)("[data-modal-ok]", this).click(function (e) {
        e.preventDefault();
        var $modal = (0, _jquery2.default)(this).closest(".modal");
        var data = (0, _jquery2.default)(".modal").find(":input").serializeArray();
        var returnArray = { 'name': 'N/A' };
        for (var i = 0; i < data.length; i++) {
            returnArray[data[i]['name'].replace("productListModalForm.", "")] = data[i]['value'];
        }
        productListService.save(returnArray).done(function (result) {
            var select2 = (0, _jquery2.default)($modal.children("div").attr("data-dropdown-target"));
            var option = new Option(result.name, result.id);
            option.selected = true;

            for (var _i = 0; _i < sources.length; _i++) {
                if (sources[_i].isEanSource) {
                    sources[_i].element.val("").trigger('change');
                    sources[_i].paramSource.val("");
                    sources[_i]._reloadTable();
                }
            }

            select2.append(option);
            select2.trigger("change");
            $modal.modal('toggle');
        }).fail(function () {
            _message2.default.error(resx.Common.AjaxError);
        });
    });

    (0, _jquery2.default)('a[data-product-lists-action-delete]', this).on('click', function () {
        var $t = (0, _jquery2.default)(this).closest(".dataTable");
        var $table = $t.DataTable();
        var data = $table.row((0, _jquery2.default)(this).parents('tr')).data();
        var productId = data.id;
        var productListId = (0, _jquery2.default)($t.attr("data-product-list-selector")).val();

        _message2.default.confirm(Resx.Messages.ConfirmDelete, Resx.Messages.ConfirmTitle).then(function () {
            productListService.deleteProduct({ ProductId: productId, ProductListId: productListId }).done(function () {
                $table.ajax.reload(null, false);
            });
        }).catch(function () {});
    });
};

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

var _notify = require("linksoft/notify");

var _notify2 = _interopRequireDefault(_notify);

var _message = require("linksoft/message");

var _message2 = _interopRequireDefault(_message);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var productListService = abp.services.api.productList;

var resx = (0, _localize2.default)("Common", "App", "Message");

;

(0, _jquery2.default)(document).on('click', '#closeModalCross', function () {
    (0, _jquery2.default)("#productsTable").DataTable().ajax.reload(null, false);
});

(0, _jquery2.default)(document).on('click', '#closeModal', function () {
    (0, _jquery2.default)("#productsTable").DataTable().ajax.reload(null, false);
});

(0, _jquery2.default)(document).on('click', '#form0', function (e) {
    e.stopPropagation();
    return true; // This should not be used unless you do not want
    // any click events registering inside the div
});

(0, _jquery2.default)(document).on('click', "#import-new-list", function () {
    (0, _jquery2.default)("#productsTable").DataTable().ajax.reload(null, false);
});

// problem with select2 and bootstrap modal
// solution: https://stackoverflow.com/questions/18487056/select2-doesnt-work-when-embedded-in-a-bootstrap-modal
_jquery2.default.fn.modal.Constructor.prototype.enforceFocus = function () {};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/productLists.js
// module id = 446
// module chunks = 0